/* eslint-disable react-hooks/exhaustive-deps */
'use client'

import NotificationIsland from 'components/shared/NotificationIsland'
import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useCallback,
} from 'react'
import * as signalR from '@microsoft/signalr'
import store from 'store'
import ClientService from 'services/ServiceEutheniaApi'
import { baseURL } from 'services/baseUrl'

const NotificationContext = createContext(undefined)

export const NotificationProvider = ({ children }) => {
  const [notification, setNotification] = useState(null)
  const [hasNotification, setHasNotification] = useState(false)
  const [hasDocuments, setHasDocuments] = useState(null)
  const [empresaId, setEmpresaId] = useState(null)
  const [podeEnfileirar, setPodeEnfileirar] = useState(false)
  const [haveAnalysis, setHaveAnalysis] = useState(false)

  const [isProcessado, setIsProcessado] = useState(false)

  const [statusRefreshKey, setStatusRefreshKey] = useState(0)

  useEffect(() => {
  if (!empresaId) return
  setIsProcessado(false)
  setHaveAnalysis(false)
}, [empresaId])

  const [resumoRefreshKey, setResumoRefreshKey] = useState(0)
  const refreshResumoMatera = useCallback(() => {
    setResumoRefreshKey((k) => k + 1)
  }, [])

  function select(state) {
    return state.auth.session.token
  }
  const token = select(store.getState())

  const notify = useCallback((type, message) => {
    setNotification({ type, message })
    setHasNotification(true)

    if (type !== 'loading' && type !== 'uploading') {
      setTimeout(() => {
        setNotification(null)
        setHasNotification(false)
      }, 2000)
    }
  }, [])

  const startLoading = useCallback((message) => {
    setNotification({ type: 'loading', message })
    setHasNotification(true)
  }, [])

  const removeNotification = useCallback(() => {
    setNotification(null)
    setHasNotification(false)
  }, [])

  useEffect(() => {
    if (!empresaId) return

    const fetchStatus = async () => {
      try {
        const response = await ClientService.fetchData({
          method: 'GET',
          url: `/integracoes/matera/ResumoDocumentosMateraPorEmpresa/${empresaId}`,
        })

        if (response?.data?.podeEnfileirarComparativo === true) {
          setPodeEnfileirar(true)
        } else {
          setPodeEnfileirar(false)
        }
      } catch (error) {
        console.error(error)
      }
    }

    fetchStatus()
  }, [empresaId, resumoRefreshKey])

useEffect(() => {
  if (!empresaId) {
    setHaveAnalysis(false)
    return
  }

  const fetchStatus = async () => {
    try {
      const response = await ClientService.fetchData({
        method: 'GET',
        url: `/integracoes/matera/ObterStatusMateraPorEmpresa/${empresaId}`,
      })
      
        if (response?.data.documentos[0]?.status === "Concluido") {
          setHaveAnalysis(true)
        }

      else setHaveAnalysis(false)
    } catch (error) {
      console.error(error)
      setHaveAnalysis(false)
    }
  }

  fetchStatus()
}, [empresaId, isProcessado, statusRefreshKey])

  // 🔌 SignalR
  useEffect(() => {
    if (!token || !empresaId) return

    const connection = new signalR.HubConnectionBuilder()
      .withUrl(
        `${baseURL}/hubs/matera-analise`,
        {
          accessTokenFactory: () => token,
          withCredentials: false,
        },
      )
      .withAutomaticReconnect()
      .build()
    connection.on('matera_status_atualizado', (data) => {
      if (data.status === 'Concluido') {
        setIsProcessado(true)
        setHaveAnalysis(true)
        setStatusRefreshKey((k) => k + 1)
      } else if (data.status === 'EmFila' || data.status === 'Processando') {
        setHaveAnalysis('processando')
      }
      notify('success', `Status Matera atualizado: ${data?.status ?? ''}`)
    })

    connection
      .start()
      .then(() => connection.invoke('EntrarGrupoEmpresa', empresaId))
      .catch((err) => {
        console.error('Erro ao conectar ao hub Matera', err)
        notify('error', 'Erro ao conectar ao hub Matera')
      })

    return () => {
      connection
        .stop()
        .catch((err) => console.error('Erro ao desconectar do hub Matera', err))
    }
  }, [empresaId, notify, token /*, refreshResumoMatera */])

  return (
    <NotificationContext.Provider
      value={{
        notify,
        startLoading,
        removeNotification,
        hasNotification,
        hasDocuments,
        setHasDocuments,
        empresaId,
        setEmpresaId,
        podeEnfileirar,
        setPodeEnfileirar,
        refreshResumoMatera,
        setHaveAnalysis,
        haveAnalysis,
      }}
    >
      {children}

      <NotificationIsland
        type={notification?.type}
        message={notification?.message}
        hasNotification={hasNotification}
      />
    </NotificationContext.Provider>
  )
}

export const useNotification = () => {
  const context = useContext(NotificationContext)
  if (!context)
    throw new Error(
      'useNotification must be used within a NotificationProvider',
    )
  return context
}
